import axios from 'axios';

import {
	type SetStoreItemQuantityRequest,
	type StoreCartLineFilters,
	type StoreCartsResponse,
	setStoreItemQuantityRequestSchema,
	storeCartLineFiltersSchema,
	storeCartResponseSchema,
	storeCartsResponseSchema,
} from '../models/items';

/** @see AppleRetail.Web.ApiControllers.OrderItemQuantityApiController.GetItemsCount */
export async function getItemsCount(signal?: AbortSignal) {
	return (await axios.get<number>('/api/bulk-order/items/count', { signal })).data;
}

/** @see AppleRetail.Web.ApiControllers.OrderItemQuantityApiController.Get */
export async function getItems(filters?: StoreCartLineFilters, signal?: AbortSignal) {
	try {
		const { data } = await axios.get<unknown>('/api/bulk-order/items', {
			params: filters ? storeCartLineFiltersSchema.parse(filters) : undefined,
			signal,
		});
		return storeCartsResponseSchema.parse(data);
	} catch {
		// TODO: Remove this catch block when the backend is fixed to return 200 with empty data instead of 400 when no items are found.
		return {
			customerOrders: [],
			nonZeroQuantityItemCount: 0,
		} satisfies StoreCartsResponse;
	}
}

/** @see AppleRetail.Web.ApiControllers.OrderItemQuantityApiController.UpdateItemQuantity */
export async function setItems(request: SetStoreItemQuantityRequest) {
	const { data } = await axios.post<unknown>(
		'/api/bulk-order/items',
		setStoreItemQuantityRequestSchema.parse(request),
	);
	return storeCartResponseSchema.parse(data);
}
